// this is an autogenerated file from App/Widget/Content/Questions/Question/Content/CreditCardCapture/mutation-authorize-card.graphql
import { gql } from 'Data/Api'

let query = gql`
mutation app__App_Widget_Content_Questions_Question_Content_CreditCardCapture($token: jsonb!) {
  leads_authorize_card(token: $token) {
    verified
    token_id
    verification_metadata {
      auth_code
      auth_message
    }
  }
}

`
export default query
